export class UrlUtil {
    static objectToString<T>(input: T): string {
        return Object.keys(input)
            .filter((key) => (input as any)[key] !== undefined && (input as any)[key] !== '' && (input as any)[key] !== null)
            .map((key) => key + '=' + (input as any)[key])
            .join('&');
    }
}
